import { ImportWarehouse } from '@/api/index'

export function warehouseGetPageGridBond (data: any) {
  return ImportWarehouse.request({
    method: 'post',
    url: '/GetPageGridBond',
    data
  })
}
export function InitializationTemplateImportWarehouse (data: any) {
  return ImportWarehouse.request({
    method: 'post',
    url: '/InitializationTemplate',
    data
  })
}
